export const formatCashString = (v) => {
  const nf = Intl.NumberFormat();
  return nf.format(Number(v));
};
